





































































































































import { Component, Prop } from 'nuxt-property-decorator';
import IAElementComponent from './IAElementComponent.vue';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'TipsCoupon'
})
export default class Tipscoupon extends IAElementComponent {
  @Prop({ type: Object, default: () => [] })
  template!: IaElementsInterface;

  get questions(): object {
    return this.$props.template.data.questions;
  }

  removeAnswers(): void {
    this.answers = [];
    this.isValidated = false;
    this.$refs.inputField.forEach((elm) => {
      elm.lazyValue = '';
    });
  }
}
